import React from "react";
import "./fallback.css";

export default function RevenueTeardownSkeleton() {
  return (
    <div className="rt-skeleton container-fluid">
      <div className="skeleton-frame">
        <div className="skeleton-head shimmer"></div>
        <div className="skeleton-body">
          <div className="skeleton-left">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="skeleton-line shimmer"></div>
            ))}
          </div>
          <div className="skeleton-right">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="skeleton-card shimmer"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
